import { useState } from "react";
import {
  updateUserProfileRequest,
  type UpdateUserProfileInput,
} from "../requests/user/profile";
import { useAuth } from "../../contexts/auth/Context";
import { useToast } from "../../contexts/toast/Context";

export const useUpdateUserProfile = (onSuccess?: () => void) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { token } = useAuth();
  const { showToast } = useToast();

  const updateUserProfile = async (input: UpdateUserProfileInput) => {
    if (!token) {
      const errorMsg = "No hay token de autenticación";
      setError(errorMsg);
      showToast(errorMsg, "error");
      return false;
    }

    setIsLoading(true);
    setError(null);

    try {
      await updateUserProfileRequest(input, token);
      showToast("Perfil actualizado", "success");
      if (onSuccess) {
        onSuccess();
      }
      return true;
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Error al actualizar el perfil";
      setError(errorMessage);
      showToast(errorMessage, "error");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    updateUserProfile,
    isLoading,
    error,
  };
};
